<template>
    <v-chip
        v-if="is_empty"
        color="info"
        small
        label
        outlined
    >
        <v-icon
            small
            left
        >
            {{ empty_icon }}
        </v-icon>
        {{ empty_label }}
    </v-chip>

    <v-menu
        v-else
        :close-on-content-click="false"
        :max-width="max_width"
        offset-y
    >
        <template #activator="{ on, attrs }">
            <v-chip
                color="info"
                class="info-chip-dropdown cursor-pointer"
                v-bind="attrs"
                v-on="on"
                small
                label
                outlined
            >
                <v-icon
                    color="info"
                    aria-hidden="true"
                    small
                    left
                >
                    {{ icon }}
                </v-icon>
                <span class="info--text">
                    {{ label }}
                </span>
                <v-icon
                    color="info"
                    aria-hidden="true"
                    small
                    right
                >
                    mdi-menu-down
                </v-icon>
            </v-chip>
        </template>

        <v-card class="info-chip-dropdown-card">
            <v-card-title class="text-subtitle-2 py-2 px-3">
                {{ dropdown_title }}
            </v-card-title>

            <v-divider />

            <v-card-text class="px-3 py-1">
                <slot name="dropdown-content" />
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    name: 'RcInfoChipDropdown',

    props: {
        icon: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        dropdown_title: {
            type: String,
            required: true,
        },
        is_empty: {
            type: Boolean,
            required: true,
        },
        empty_icon: {
            type: String,
            required: true,
        },
        empty_label: {
            type: String,
            required: true,
        },
        max_width: {
            type: [String, Number],
            default: 400,
        },
    },
};
</script>

<style lang="scss" scoped>
// match height of small v-btn for inline display
.v-chip.v-size--small {
    height: 28px;
}
.info-chip-dropdown-card {
    max-width: 100%;
}
</style>
